/** @jsxImportSource ../../i18n */
import React, { useEffect, useRef, useState } from 'react';
import { prefersReducedMotion } from '../../theme/motion';

const easeOut = (t) => 1 - (1 - t) ** 3;

const canAnimate = () => !prefersReducedMotion() && typeof requestAnimationFrame === 'function';

export const AnimatedNumber = ({ value, format = (v) => String(v), duration = 700, className }) => {
  const target = Number(value);
  const [display, setDisplay] = useState(() => (Number.isFinite(target) && canAnimate() ? target * 0.94 : target));
  const current = useRef(display);

  useEffect(() => {
    if (!Number.isFinite(target) || !canAnimate()) {
      current.current = target;
      setDisplay(target);
      return undefined;
    }
    const from = current.current;
    if (from === target) return undefined;
    const start = performance.now();
    let frame = requestAnimationFrame(function step(now) {
      const t = Math.min((now - start) / duration, 1);
      const next = t === 1 ? target : from + (target - from) * easeOut(t);
      current.current = next;
      setDisplay(next);
      if (t < 1) frame = requestAnimationFrame(step);
    });
    return () => cancelAnimationFrame(frame);
  }, [target, duration]);

  return <span className={className}>{format(Number.isFinite(target) ? display : value)}</span>;
};
